import React from 'react'
import flow from 'lodash/flow'
import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'
import isTestEnv from '@signal/utils/env/isTest'

const toPascal = flow(camelCase, upperFirst)

export function getImportSvg() {
  // Process svgs through the `svgr/webpack` loader.
  // do not call require.context in a jest environment
  const importSvg = require.context(
    '!@svgr/webpack!../svg',
    false, // No need to load files recursively.
    /^\.\/.*\.svg$/ // Match files ending with .svg.
  )
  return importSvg
}

export const getSvg = name => {
  // return pascal case name for test env
  if (isTestEnv()) return props => <svg {...props}>{toPascal(name)}</svg>
  const importSvg = getImportSvg()
  return importSvg(`./${name}.svg`).default
}

export default getSvg
